module.exports = __webpack_public_path__ + "static/media/sidemenu-search.9117061d.svg";